import axios from 'axios'
import authHeader from "./auth-header";

export class WorkloadCoefficientService {

    getWorkloadCoefficients() {
        return axios.get('/api/workload-coefficient', {headers: authHeader()})
            .then(res => res.data);
    }

    getWorkloadCoefficientsPivot() {
        return axios.get('/api/workload-coefficient/pivot', {headers: authHeader()})
            .then(res => res.data);
    }

    saveWorkloadCoefficient(workloadCoefficient) {
        return axios.post('/api/workload-coefficient', workloadCoefficient, {headers: authHeader()})
            .then(res => res.data);
    }

    deleteWorkloadCoefficient(id) {
        return axios.delete(`/api/workload-coefficient/${id}`, {headers: authHeader()})
            .then(res => res.data);
    }
}
